import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VIcon,_vm._g(_vm._b({attrs:{"color":"grey","dark":""}},'v-icon',attrs,false),on),[_vm._v("help")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t('You have no permissions for this')))])])}
var staticRenderFns = []

export { render, staticRenderFns }